// function validateForm() {
//   // �ڋq�ԍ��̃o���f�[�V����
//   let billNo = document.getElementsByName('bill_no')[0].value;
//   if (!/^\d{12}$|^\d{14}$/.test(billNo)) {
//       alert('�ڋq�ԍ���12���܂���14���̔��p�����œ��͂��Ă��������B');
//       document.getElementsByName('bill_no')[0].focus();
//       return false;
//   }

//   // �ڋq�J�i���̃o���f�[�V����
//   let billKana = document.getElementsByName('bill_kana')[0].value;
//   if (!/^[�-�]+$/.test(billKana) || billKana.length > 60) {
//       alert('�ڋq�J�i���͔��p�J�^�J�i60�����ȓ��œ��͂��Ă��������B');
//       document.getElementsByName('bill_kana')[0].focus();
//       return false;
//   }

//   // ���N�����̃o���f�[�V����
//   let billBirth = document.getElementsByName('bill_birth')[0].value;
//   if (!/^\d{8}$/.test(billBirth)) {
//       alert('���N������8���̔��p�����iYYYYMMDD�j�œ��͂��Ă��������B');
//       document.getElementsByName('bill_birth')[0].focus();
//       return false;
//   }

//   // �X�֔ԍ��̃o���f�[�V����
//   let billZip = document.getElementsByName('bill_zip')[0].value;
//   if (!/^\d{3}-?\d{4}$/.test(billZip)) {
//       alert('�X�֔ԍ��́u123-4567�v�܂��́u1234567�v�̌`���œ��͂��Ă��������B');
//       document.getElementsByName('bill_zip')[0].focus();
//       return false;
//   }

//   // �d�b�ԍ��̃o���f�[�V����
//   let billPhone = document.getElementsByName('bill_phon')[0].value;
//   if (!/^\d{2,4}-?\d{2,4}-?\d{4}$/.test(billPhone)) {
//       alert('�d�b�ԍ��́u012-345-6789�v�̌`���œ��͂��Ă��������B');
//       document.getElementsByName('bill_phon')[0].focus();
//       return false;
//   }

//   // ���[���A�h���X�̃o���f�[�V����
//   let billMail = document.getElementsByName('bill_mail')[0].value;
//   if (!/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(billMail) || billMail.length > 256) {
//       alert('�L���ȃ��[���A�h���X��256�����ȓ��œ��͂��Ă��������B');
//       document.getElementsByName('bill_mail')[0].focus();
//       return false;
//   }

//   return true;
// }